import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { AUDIOVISUAL_CAPABILITIES, SLATE, BRAIN_LAB } from "@/data/site";
import { serif, mont, COLORS, es } from "./ui";

const V2Audiovisual = () => {
  return (
    <div data-testid="v2-audiovisual">
      <section className="max-w-6xl mx-auto px-6 pt-10 pb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] mb-5" style={{ ...mont, color: COLORS.gold, fontWeight: 600 }}>Estudio de desarrollo · Producción</p>
          <h1 className="text-5xl sm:text-6xl font-light leading-[1]" style={serif}>Creamos historias en imágenes</h1>
          <p className="mt-7 text-lg leading-relaxed max-w-2xl" style={{ color: COLORS.sec }}>
            Documentales, películas, series y programas de producción propia y coproducción. Detectamos historias,
            las escribimos, buscamos financiación y las llevamos a la pantalla.
          </p>
        </Reveal>
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-8" style={{ borderTop: `1px solid ${COLORS.border}`, paddingTop: "3rem" }}>
        {AUDIOVISUAL_CAPABILITIES.map((c, i) => (
          <Reveal key={c.id} delay={(i % 3) * 0.08}>
            <div className="bg-white h-full" style={{ border: `1px solid ${COLORS.border}` }}>
              <div className="overflow-hidden aspect-[16/10]">
                <img src={c.image} alt={es(c.title)} className="w-full h-full object-cover" style={{ filter: "grayscale(0.1)" }} />
              </div>
              <div className="p-7">
                <h3 className="text-2xl font-normal" style={serif}>{es(c.title)}</h3>
                <p className="mt-3 text-sm leading-relaxed" style={{ color: COLORS.sec }}>{es(c.desc)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      {/* Brain Lab */}
      <section className="py-20" style={{ backgroundColor: COLORS.ink, color: "#FBF9F5" }}>
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-xs uppercase tracking-[0.3em] mb-6" style={{ ...mont, color: COLORS.gold, fontWeight: 600 }}>{es(BRAIN_LAB.title)}</p>
          <p className="text-2xl sm:text-3xl font-light leading-snug" style={serif}>{es(BRAIN_LAB.desc)}</p>
        </div>
      </section>

      {/* Producciones destacadas */}
      <section className="max-w-6xl mx-auto px-6 py-20">
        <h2 className="text-4xl font-light mb-12" style={serif}>Producciones destacadas</h2>
        <div className="grid md:grid-cols-2 gap-10">
          {SLATE.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.1}>
              <div className="group">
                <div className="overflow-hidden aspect-[16/10] mb-5" style={{ border: `1px solid ${COLORS.border}` }}>
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" style={{ filter: "grayscale(0.1)" }} />
                </div>
                <p className="text-[10px] uppercase tracking-[0.22em]" style={{ ...mont, color: COLORS.gold, fontWeight: 600 }}>{es(s.format)} · {s.year} · {es(s.status)}</p>
                <h3 className="mt-2 text-3xl font-normal" style={serif}>{s.title}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default V2Audiovisual;
